import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import * as T from '../../services/types'
import {RootState} from '../../store'
import {ACCESSED_MENU} from '../../constants/accessedMenu'

export interface IState {
  user: T.IAuthLoginResponse | null
  accessedMenu: T.IAuthLoginResponse['accesses']['role_accesses'] | null
  roleId: number | null
  credential: string | null
}

const initialState: IState = {
  user: null,
  accessedMenu: ACCESSED_MENU,
  roleId: null,
  credential: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthUser: (state: IState, action: PayloadAction<IState['user']>) => {
      // Set user
      state.user = action.payload

      // Set accessedMenu
      const listMenu = action.payload?.accesses.role_accesses ?? null
      state.accessedMenu = !listMenu
        ? ACCESSED_MENU
        : listMenu.filter((item) => item.read === true).sort((a, b) => a.menu.sort - b.menu.sort)

      // Set roleId
      state.roleId = state.user?.accesses.id ?? null
    },
    setMenu: (state: IState, action: PayloadAction<IState['accessedMenu']>) => {
      const listMenu = action.payload
      state.accessedMenu = !listMenu
        ? ACCESSED_MENU
        : listMenu.filter((item) => item.read === true).sort((a, b) => a.menu.sort - b.menu.sort)
    },
    setCredential: (state: IState, action: PayloadAction<IState['credential']>) => {
      state.credential = action.payload
    },
  },
})

export const {setAuthUser, setMenu, setCredential} = authSlice.actions

export const authSelector = (state: RootState) => state.authPersistedReducer
export default authSlice.reducer
